import {CardMedia, IconButton} from '@mui/material';
import activityIndicatorCircle from '../../assets/circle_activity_indicator.svg';
import inactivityIndicatorCircle from '../../assets/circle_inactivity_Indicator.svg';
import React, {useRef, useState} from "react";
import CardViewAdFooter from "./CardViewAdFooter";
import {BookmarkBorderOutlined, FileDownloadOutlined, Pause, PlayArrow} from '@mui/icons-material'; // Añadido 'Pause'
import {DownloadImgFromUrl} from "../../services/DownloadSvc";
import './cardViews.css';
import logoBeta from "./../../assets/logobeta.png"
import { normalizeCreativeUrl } from '../../utils/Utils';


// Create the PostCard component that accepts `item` as a prop
export default function CardViewAdDetail({index, item, launchCategoryDialog, gridShowAdDetail, isVault = false}) {

    /*  INIT VARS - HOOKS   */

    /**
     * Configura la propiedad 'display' ('none','block') del toolbar. De esta manera se oculta o se muestran
     * los botones de accion del cardView
     */
    const [displayToolbar, setDisplayToolbar] = useState('none');
    const mainVideoRef = useRef(null);
    const backgroundVideoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);  // (ECA) Seguimiento al estado de reproducción del vídeo
    /**
     * Estilo para los botones de accion.
     * @type {{backgroundColor: string, color: string, "&:hover": {background: string}}}
     */
    const styleBtnIcon = {
        backgroundColor: 'white', color: 'black', '&:hover': {background: '#c5bebe'}, ml: 1
    };
    /*  END VARS - HOOKS   */


    /*  INIT EVENTS */

    /**
     * Mostras los botones de accion en el card
     */
    const showActionButtons = () => {
        setDisplayToolbar('block')
    }
    /**
     * Ocultar los botones de accion en el card
     */
    const hideActionButtons = () => {
        setDisplayToolbar('none')
    }
    /**
     * Descargar el creativo
     * @param fileType
     * @param src
     * @return {Promise<void>}
     */
    const onclickDownloadCreative = async (fileType, src) => {
        await DownloadImgFromUrl(src, fileType)
    }

    /**
     * (ECA) Función para controlar la reproducción de videos
     */
    const togglePlayVideo = async (accion) => {
        if (accion === "video") {
            if (mainVideoRef.current && backgroundVideoRef.current) {
                if (isPlaying) {
                    mainVideoRef.current.pause();
                    backgroundVideoRef.current.pause();
                    setIsPlaying(false);
                } else {
                    try {
                        await mainVideoRef.current.play();
                        backgroundVideoRef.current.muted = true;
                        backgroundVideoRef.current.play();
                        setIsPlaying(true);
                    } catch (error) {
                        console.error("Error trying to play video:", error);
                        setIsPlaying(false);
                    }
                }
            }
        }
    };

    /**
     * (ECA) Manejo del clic en la grilla para mostrar los detalles
     */
    const onClickCardView = (e) => {
        if (e.target.className === "card-view-ad-layout-shadow") {
            if (gridShowAdDetail) {
                gridShowAdDetail(item);
            }
        }
        if (e.target.className === "toggle-button") {
            return false;
        }
    }

    /*  END EVENTS  */

    const adCreativeSrc = normalizeCreativeUrl(item?.AdCreative);

    return (
        <div
            className={"card-view-ad-layout-main-detail"}
            onMouseOver={showActionButtons}
            onMouseOut={hideActionButtons}> {/* Set position to relative */}
            <div style={{height: '460px', width: '460px', overflow: 'hidden', position: 'relative'}}>
                
                {item?.AdMedia === 'video' ? ( // Conditional rendering: Check if the media type is a video

                    <>
                        <video
                            id="background-video"
                            ref={backgroundVideoRef}
                            
                            src={adCreativeSrc}
                            style={{
                                width: '100%',
                                height: '100%',
                                filter: 'blur(10px)',
                                objectFit: 'cover',
                                top: '0px',
                                left: '0px',
                                zIndex: 0,
                                opacity: 0.8,
                                position: 'absolute'
                            }}
                        />
                        <video
                            id="main"
                            ref={mainVideoRef}
                            
                            src={adCreativeSrc}
                            style={{
                                height: '100%',
                                width: '100%',
                                objectFit: 'contain',
                                objectPosition: 'center center',
                                transition: 'filter 500ms',
                                zIndex: 5,
                                position: 'relative'
                            }}
                        />

                    </>


                ) : (
                    <img
                        src={adCreativeSrc}
                        alt={item?.AdTitle}
                        style={{height: '100%', width: '100%', objectFit: 'cover'}}
                    />
                )}
            </div>
            <div className={"card-view-ad-layout-shadow"} onClick={onClickCardView}
                 style={{display: displayToolbar, zIndex: 10}}>
                <div className={"card-view-ad-layout-shadow-container-buttons"}>
                    <IconButton sx={styleBtnIcon}>
                        <FileDownloadOutlined className="download-icon"
                            onClick={(e) => {
                                onclickDownloadCreative(item?.AdMedia, adCreativeSrc)
                            }}/>
                    </IconButton>
                    {
                        !isVault && (
                            <IconButton sx={styleBtnIcon} onClick={(e) => launchCategoryDialog(item)}>
                                <BookmarkBorderOutlined className="bookmark-icon"/>
                            </IconButton>
                        )
                    }
                    {
                        item?.AdMedia === 'video' && (
                            <IconButton onClick={(e) => togglePlayVideo('video')}
                                        sx={
                                            {
                                                backgroundColor: 'white',
                                                color: 'black', float: 'right',
                                                mr: 1,
                                                '&:hover': {background: '#c5bebe'}
                                            }
                                        }>
                                {isPlaying
                                    ? <Pause className="pause-icon" fontSize="large"/>
                                    : <PlayArrow className="play-icon" fontSize="large"/>}
                                {/* Mostrar el icono de reproducción/pausa */}
                            </IconButton>
                        )
                    }
                </div>
            </div>
            {/* Footer Section */}
            <CardViewAdFooter index={index} item={item} activityIndicatorCircle={activityIndicatorCircle}
                              inactivityIndicatorCircle={inactivityIndicatorCircle}/>
        </div>
    )// end return
} // end main function